export type ITimberlandAppraisalFormSixthSection = {
    Signature?: string;
    SignatureDate?: string;
}

export const TimberlandAppraisalFormSixthSectionInterface = (): ITimberlandAppraisalFormSixthSection => ({
    Signature: undefined,
    SignatureDate: undefined
})